

const LoadMore = ({ callVideos }) => {
    return <div className="ytvgbLoadMoreBtn">
        <button onClick={callVideos}>Load More</button>
    </div>
}
export default LoadMore;